export enum RoleType {
  GUEST = 'GUEST',
  PROJECT_MEMBER = 'PROJECT_MEMBER',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  PROJECT_DEPUTY_MANAGER = 'PROJECT_DEPUTY_MANAGER',
  DEPARTMENT_MANAGER = 'DEPARTMENT_MANAGER',
  DEPARTMENT_DEPUTY_MANAGER = 'DEPARTMENT_DEPUTY_MANAGER',
}
